<template>
    <reports-base
        exportable
        reportsName="invalidUsageProducts"
        reportsTitle="Użycia zweryfikowane negatywnie"
        componentName="InvalidUsageProducts"
        @onExport="onExport"
    >
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    components: {
        ReportsBase
    },
    methods: {
        onExport() {
            this.$store.dispatch('invalidUsageProductsReportDownload')
        }
    }
}
</script>
